import React from 'react';
import { ArrowUp, ArrowDown, Minus } from 'lucide-react';
import { cn } from '@/lib/utils';
import type { ColumnDef, SortClause } from '@/hooks/useReportBuilder';

interface Props {
  columns: ColumnDef[];
  selected: string[]; // only show selected columns
  sortBy: SortClause[];
  onToggle: (col: string) => void;
}

export const SortPanel: React.FC<Props> = ({ columns, selected, sortBy, onToggle }) => {
  const activeCols = columns.filter(c => selected.includes(c.key));
  if (activeCols.length === 0) return null;

  return (
    <div className="space-y-1.5">
      <p className="text-xs font-semibold uppercase tracking-widest text-muted-foreground px-1">Ordenação</p>
      <div className="flex flex-wrap gap-1.5">
        {activeCols.map(col => {
          const sort = sortBy.find(s => s.column === col.key);
          return (
            <button
              key={col.key}
              onClick={() => onToggle(col.key)}
              className={cn(
                'flex items-center gap-1.5 rounded-md border px-2.5 py-1.5 text-xs transition-colors',
                sort
                  ? 'border-primary/50 bg-primary/10 text-primary font-medium'
                  : 'border-border/50 bg-background text-muted-foreground hover:bg-muted hover:text-foreground'
              )}
            >
              {sort?.dir === 'asc' && <ArrowUp className="h-3 w-3" />}
              {sort?.dir === 'desc' && <ArrowDown className="h-3 w-3" />}
              {!sort && <Minus className="h-3 w-3 opacity-30" />}
              {col.label}
            </button>
          );
        })}
      </div>
      <p className="text-xs text-muted-foreground px-1">Clique para ciclar: ↑ asc → ↓ desc → sem ordenação</p>
    </div>
  );
};
